export default "__VITE_ASSET__BIi$_woA__"